import { forwardRef } from 'react';

import type { LucideProps } from 'lucide-react';

/** Windows-style offline/internet globe: a sphere with a simple grid. */
const InternetGlobeIcon = forwardRef<SVGSVGElement, LucideProps>(
  (
    {
      color = 'currentColor',
      size = 24,
      strokeWidth = 1.8,
      absoluteStrokeWidth,
      ...props
    },
    ref
  ) => {
    const resolvedStrokeWidth = absoluteStrokeWidth
      ? (Number(strokeWidth) * 24) / Number(size)
      : strokeWidth;

    return (
      <svg
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        strokeWidth={resolvedStrokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
        {...props}
      >
        <circle cx="12" cy="12" r="9" />
        <path d="M3 12h18" />
        <path d="M12 3c2.45 2.47 3.7 5.47 3.7 9S14.45 18.53 12 21" />
        <path d="M12 3C9.55 5.47 8.3 8.47 8.3 12S9.55 18.53 12 21" />
      </svg>
    );
  }
);

InternetGlobeIcon.displayName = 'InternetGlobeIcon';

export default InternetGlobeIcon;
